export default __webpack_public_path__ + "static/media/logo.8481ee87.png";